import { ButtonProps, Flex } from "@chakra-ui/react";
import { Next, PageGroup, Paginator, Previous } from "chakra-paginator";
import { FC } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const baseStyles: ButtonProps = {
    w: 7,
    fontSize: "sm"
};

const normalStyles: ButtonProps = {
    ...baseStyles,
    _hover: {
        bg: "teal.700"
    },
    bg: "teal.500"
};

const activeStyle: ButtonProps = {
    ...baseStyles,
    bg: "teal.200"
};

interface LogosTablePaginationProps {
    currentPage: number;
    pagesQuantity: number;
    handlePageChange: any
}

const LogosTablePagination: FC<LogosTablePaginationProps> = ({ currentPage, pagesQuantity, handlePageChange }) => {
    return (
        <Paginator
            isDisabled={false}
            innerLimit={1}
            outerLimit={1}
            activeStyles={activeStyle}
            normalStyles={normalStyles}
            separatorStyles={normalStyles}
            currentPage={currentPage}
            pagesQuantity={pagesQuantity}
            onPageChange={handlePageChange}
        >
            <Flex mt={4}>
                <Previous mr={1}>
                    <FiChevronLeft size={'1.5em'} />
                </Previous>
                <PageGroup isInline align="center" />
                <Next ml={1}>
                    <FiChevronRight size={'1.5em'} />
                </Next>
            </Flex>
        </Paginator>
    );
};

export default LogosTablePagination;